<template>
  <div v-if="isTrialAccount && trialStartDate" class="trial-countdown">
    You have <span class="days">{{ daysLeft }} days</span> left on your trial
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "TrialCountdown",
  computed: {
    ...mapState("layout", {
      isTrialAccount: state => state.systemSetting?.isTrialAccount,
      trialDaysLimit: state => state.systemSetting?.trialDaysLimit,
      trialStartDate: state => state.systemSetting?.trialStartDate
    }),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    daysLeft() {
      const startDate = new Date(this.trialStartDate);
      const endDate = startDate.setDate(
        startDate.getDate() + this.trialDaysLimit
      );
      const daysLeft = Math.round(
        (endDate - this.getCurrentAdjustedDateTime()) / (1000 * 60 * 60 * 24)
      );

      return Math.max(daysLeft, 0);
    }
  }
};
</script>

<style scoped>
.days {
  color: #363abb;
  font-weight: bold;
}
</style>
